export default __webpack_public_path__ + "locales/pl/About.json?hash=8fb425168ffc8e94267ea39420a38e53";